import axiosClient from "./axiosClient";
import { apiEndpoints, secureBusinessKey } from "./apiEndpoints";
import Cookies from "js-cookie";
import { Bounce, toast } from "react-toastify";
// Fetch employees for a specific service ID
export const fetchEmployees = ({ serviceId }) =>
  axiosClient.get(apiEndpoints.employees.url(serviceId), {
    headers: {
      "secure-business-key": secureBusinessKey,
      uuid: apiEndpoints.employees.uuid,
    },
  });

// Search employees by service ID and branch ID
export const searchEmployees = (serviceId, branchId) =>
  axiosClient.get(apiEndpoints.employeesSearch.url(serviceId, branchId), {
    headers: {
      "secure-business-key": secureBusinessKey,
      uuid: apiEndpoints.employeesSearch.uuid,
    },
  });

// Fetch specialists' availability by employee IDs
export const fetchSpecialists = (employeeIds, duration) => {
  const branchId = Cookies.get("brunch_id");

  const personal_token = Cookies.get("personal_token");

  const sessionExpired = (msg) => {
    toast(msg, {
      style: {
        background: "#f87171",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "2rem",
        padding: "1rem",
        width: "20dvh",
      },
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
      theme: "colored",
      transition: Bounce,
      closeButton: ({ closeToast }) => (
        <button
          className="text-white text-4xl leading-none rounded-full p-2"
          onClick={closeToast}
        >
          ×
        </button>
      ),
    });
  };

  if (!branchId || !personal_token) {
    sessionExpired("Session has expired");
    setTimeout(() => {
      window.location.href = "/logout";
    }, 3000);
    return Promise.reject(
      new Error("Branch ID is missing. Redirecting to logout.")
    );
  }
  const res = axiosClient.post(
    `${process.env.REACT_APP_CALENDAR_BASE_URL}/api/available-specialists`,
    { employee_id: employeeIds, branch_id: branchId, duration: duration },
    {
      headers: {
        "secure-business-key": secureBusinessKey,
        "Content-Type": "application/json",
        "user-token": personal_token,
      },
    }
  );
  // console.log(res, "res");
  return res;
};

export const getEmployeeName = (userId) => {
  return axiosClient.get(apiEndpoints.employeesName.url(userId), {
    headers: {
      "secure-business-key": secureBusinessKey,
      uuid: apiEndpoints.employeesName.uuid,
      Accept: "application/json",
    },
  });
};
